module.exports = __webpack_public_path__ + "static/10-f29005e3e4ee901cd9e5f7a75a9118a0.jpg";